import { FC, ReactNode } from 'react';

interface IFloatButtons {
  children: ReactNode;
}

const FloatButtons: FC<IFloatButtons> = ({ children }: IFloatButtons) => {
  return (
    <div id="floatButtons">
      <div className="containerButtons">{children}</div>
    </div>
  );
};

export default FloatButtons;
